import React from 'react';
import ReactDOM from 'react-dom';
// import App from './App/App';
import App from './App/Facebook';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
); 
